<template>
  <div id="container" :style="popUpStyle">
    <div v-if="gamePhase.phase == 1 && gamePhase.first.end" class="first pop">
      <div class="header">• Barq •</div>
      <div class="image" :style="loadImg('first')"></div>
      <div class="first_text" v-html="t('first_text')"></div>
    </div>
    <div
      v-else-if="gamePhase.phase == 2 && gamePhase.second.end"
      class="second second_normal pop"
    >
      <div class="header">• Barq •</div>
      <div class="image" :style="loadImg('second_normal')"></div>
      <div class="second_text orange bold">
        {{ t("second_normal_text") }}
      </div>
    </div>
    <div
      v-else-if="gamePhase.phase == 2 && gamePhase.second.yeah"
      class="second second_yeah pop"
    >
      <div class="header">• Barq •</div>
      <div class="image" :style="loadImg('second_yeah')"></div>
      <div class="second_text orange bold">
        {{ t("second_yeah_text") }}
      </div>
    </div>
  </div>
</template>

<script>
import Dict from "../../services/dict_new.js";

export default {
  name: "RoundPopUp",
  components: {},
  props: {
    gamePhase: {
      type: Object,
      default: () => {},
    },
    sprache: {
      type: String,
      default: () => "english",
    },
  },
  watch: {
    gamePhase: function (newVal) {
      // watch it
      // console.log(
      //   "POPUPOPUOPPOPUPOPUOPPOPUPOPUOPPOPUPOPUOPPOPUPOPUOPPOPUPOPUOPPOPUPOPUOPPOPUPOPUOP"
      // );
      // console.log(newVal);
      try {
        if (newVal.phase == 1 && newVal.first.end) {
          console.log("first popup");
          this.popUpStyle = "display:inherit";
        } else if (newVal.phase == 2 && newVal.second.end) {
          console.log("second normal popup");
          this.popUpStyle = "display:inherit";
        } else if (newVal.phase == 2 && newVal.second.yeah) {
          console.log("second yeah popup");
          this.popUpStyle = "display:inherit";
        } else {
          this.popUpStyle = "display:none";
        }
      } catch (e) {
        console.log(e);
        this.popUpStyle = "display:none";
      }
    },
  },
  emits: ["msg", "getImage"],
  data() {
    return {
      popUpStyle: "display:none",
    };
  },
  methods: {
    t(word) {
      return Dict(word, this.sprache);
    },
    loadImg(name) {
      // console.log("TRYOING TO LOAD:" + teleId);
      let img = "";
      let img2 = "";
      try {
        img = require("../assets/" + name + ".jpg");
      } catch (e) {
        console.log("img not found");
        this.$emit("msg", "Could not load img1");
        // this.currentOpenTele = "";
      }
      try {
        img2 = require("../assets/" + name + "_min.jpg");
      } catch (e) {
        this.$emit("msg", "Could not load img2");
        // this.currentOpenTele = "";
      }
      return "background-image: url('" + img + "'),url('" + img2 + "');";
    },
  },
  created() {
  },
};
</script>
<style>
.bold {
  font-style: bold;
}

.orange {
  color: var(--barq-orange);
}

.italic {
  font-style: italic;
}

.grey {
  color: #595959;
}
</style>
<style scoped>
#container {
  position: fixed;
  z-index: 4;
  background: #f2f2f2;
  width: 100%;
  height: 100%;
  left: 0px;
  top: 0px;
}

.second_text {
  font-size: 40px;
  text-align: center;
}

.second {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-around;
}

.first_text {
  display: flex;
  height: 400px;
  flex-wrap: wrap;
  width: 500px;
  padding: 50px;
}

.header {
  position: absolute;
  left: 50%;
  transform: translateX(-50%);
  color: white;
  top: -32px;
  font-size: 25px;
}

.pop:before {
  content: " ";
  position: absolute;
  top: -38px;
  left: -38px;
  right: -38px;
  bottom: -38px;
  border: 3px solid white;
  border-radius: 40px;
}

.pop {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translateX(-50%) translateY(-50%);
  border: 40px solid var(--barq-orange);
  border-radius: 40px;
  width: 80%;
  height: 80%;
}

.first {
  display: flex;
  align-items: center;
  align-content: center;
}

.image {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
}

.first > .image {
  height: 500px;
  width: 850px;
}

.second_yeah > .image {
  height: 500px;
  width: 335px;
}

.second_normal > .image {
  height: 500px;
  width: 925px;
}
</style>
